export const getPaginationUlStylesAsClassName = 'list-none';

export const getPaginationLiStylesAsClassName = 'inline-block align-middle';
